import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  // Check if user is already authenticated
  const userId = localStorage.getItem('userId');
  
  // If authenticated, redirect to dashboard
  if (userId) {
    console.log('✅ User already logged in, redirecting to create-post');
    return <Navigate to="/create-post" replace />;
  }
  
  // If not authenticated, show the public page (login/signup)
  return children;
};

export default PublicRoute;